import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
type PageHeroProps = {
  breadcrumb: string;
  title: string;
  lead: string;
  image?: string;
  imageAlt?: string;
};
export function PageHero({
  breadcrumb,
  title,
  lead,
  image,
  imageAlt
}: PageHeroProps) {
  return <section className="border-b border-line bg-white" data-id="element-102" data-mp="22pjs246fvrt">
      <div className="mx-auto max-w-content px-6 pt-10" data-id="element-103" data-mp="25c28wslvvot">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1 text-[13px] text-ink-muted" data-id="element-104" data-mp="puegrvry18f3">
          <Link to="/" className="transition-colors duration-150 ease-smooth hover:text-signal" data-id="element-105" data-mp="uqv62tavpstr">
            Accueil
          </Link>
          <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-106" data-mp="g1fs6dwg5hvh" />
          <span className="text-ink" data-id="element-107" data-mp="l0sfezr8cqyl">{breadcrumb}</span>
        </nav>
      </div>
      <div className={`mx-auto grid max-w-content gap-10 px-6 pb-14 pt-8 md:pb-20 ${image ? 'lg:grid-cols-[1.05fr_0.95fr] lg:items-center' : ''}`} data-id="element-108" data-mp="18qwfwy94gald">
        <div data-id="element-109" data-mp="32hivb1murh5k">
          <h1 className="max-w-3xl text-4xl font-semibold leading-[1.08] tracking-tight text-ink md:text-5xl" data-id="element-110" data-mp="32jdh0i5y7dap">
            {title}
          </h1>
          <p className="mt-6 max-w-2xl text-[18px] leading-relaxed text-ink-soft" data-id="element-111" data-mp="2xhebp2qne6b4">{lead}</p>
        </div>
        {image && <figure className="overflow-hidden bg-bone" data-id="element-112" data-mp="37gvhdk5wgk73">
            <img src={image} alt={imageAlt ?? ''} className="h-full w-full object-cover" loading="eager" width={1000} height={750} data-id="element-113" data-mp="37g3tkvijnqrd" />
          </figure>}
      </div>
    </section>;
}